import { periodToRange } from '../../api/dashboards'
import { productivityApi, type ProductivityKey } from '../../api/productivity'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { Stat, WidgetBody, formatNum } from './WidgetBody'

const LABELS: [ProductivityKey, string][] = [
  ['tasksCompleted', 'Task completati'],
  ['tasksOverdueOpen', 'Task scaduti aperti'],
  ['leadsWorked', 'Lead lavorati'],
  ['callAttempts', 'Chiamate'],
  ['appointmentsCompleted', 'Appuntamenti fatti'],
  ['practicesCreated', 'Pratiche inserite'],
  ['practicesProcessed', 'Pratiche lavorate'],
  ['outOfSlaNow', 'Fuori SLA adesso'],
]

/** I miei KPI di produttività: le definizioni stanno nella pagina Produttività. */
export function MyProductivityWidget({ item }: WidgetProps) {
  const range = periodToRange(item.filters?.period)
  const state = useWidgetData(() => productivityApi.mine(range), JSON.stringify(range))
  return (
    <WidgetBody state={state}>
      {report => {
        const m = report.rows[0]?.metrics
        if (!m) return <div className="text-muted md-typescale-body-small">Nessun dato nel periodo.</div>
        return (
          <>
            <div className="md-mini-stats">
              {LABELS.map(([key, label]) => (
                <Stat key={key} label={label} value={formatNum(m[key])} />
              ))}
            </div>
            <div className="text-muted md-typescale-body-small mt-2">
              {report.from} → {report.to}
            </div>
          </>
        )
      }}
    </WidgetBody>
  )
}
